export enum InvoiceState {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    CLEARED = 'CLEARED',
}
